// extracted by mini-css-extract-plugin
export default {"root":"RoundTimer-module__root","svg":"RoundTimer-module__svg","circle":"RoundTimer-module__circle"};